export default "__VITE_ASSET__BEQGhm0b__"